import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[wizardStep]',
  standalone: true
})
export class SFormWizardStepDirective {
  @Input() wizardStep?: string;
  @Input() preRender: boolean;

  readonly template = inject(TemplateRef);
}
